/* ================================================================
   THEME.JS - Hediye Kutusu | Vanilla JS, framework yok

   Mimari notlar:
   - Her bilesen HK.register(selector, initFn) ile kaydedilir.
   - Bilesenler hem DOMContentLoaded'da hem de shopify:section:load
     olayinda kurulur -> Theme Editor'de bir bolum duzenlenince
     o bolumun JS'i olmez (onceki surumdeki hata).
   - el.__hkInit bayragi cift baglamayi engeller.
   - Drawer'larda focus trap + Escape + odak iadesi vardir (WCAG 2.2).
================================================================ */
'use strict';

var HK = (function () {
  /* ---------- Utility ---------- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  var prefersReducedMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---------- Scroll kilidi ----------
     Drawer aciklen arka planin kaymasini engeller. Sayfayi zorla en uste
     tasimadigi icin (position:fixed hilesi yok) geri acildiginda ziplama olmaz.
     Ic ice acilislari saymak icin sayac kullanilir. */
  var lockCount = 0;
  function lockScroll() {
    if (lockCount === 0) {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    }
    lockCount++;
  }
  function unlockScroll(force) {
    lockCount = force ? 0 : Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  /* ---------- Focus trap ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(container, opener) {
    if (!container) return function () {};
    var previous = opener || document.activeElement;

    function keydown(e) {
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    container.addEventListener('keydown', keydown);
    var firstEl = $$(FOCUSABLE, container)[0];
    if (firstEl) setTimeout(function () { firstEl.focus(); }, 60);

    return function release() {
      container.removeEventListener('keydown', keydown);
      if (previous && typeof previous.focus === 'function') previous.focus();
    };
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'hk-stock-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  }

  /* ---------- Bilesen kayit defteri ---------- */
  var registry = [];
  function register(selector, init) { registry.push({ selector: selector, init: init }); }

  function initAll(root) {
    root = root || document;
    registry.forEach(function (entry) {
      var nodes = $$(entry.selector, root);
      if (root.matches && root.matches(entry.selector)) nodes.unshift(root);
      nodes.forEach(function (el) {
        if (el.__hkInit) return;
        el.__hkInit = true;
        try { entry.init(el); }
        catch (err) { console.error('[hk] bilesen hatasi:', entry.selector, err); }
      });
    });
  }

  return {
    $: $, $$: $$, on: on,
    register: register, initAll: initAll,
    lockScroll: lockScroll, unlockScroll: unlockScroll,
    trapFocus: trapFocus, toast: toast,
    prefersReducedMotion: prefersReducedMotion
  };
})();

window.HK = HK;
window.hkStockToast = HK.toast; /* geriye donuk uyumluluk (cart.js, product-main) */

(function () {
  var $ = HK.$, $$ = HK.$$, on = HK.on;

  /* ================= Announcement Bar ================= */
  HK.register('.announcement-bar', function (el) {
    var close = $('.announcement-bar__close', el);
    if (!close) return;
    if (sessionStorage.getItem('hk_ann_closed')) { el.hidden = true; return; }
    on(close, 'click', function () {
      el.hidden = true;
      try { sessionStorage.setItem('hk_ann_closed', '1'); } catch (e) {}
    });
  });

  /* ================= Global drawer'lar (layout'ta, bir kez baglanir) ============= */
  var globalsBound = false;
  var releaseMenu = null;
  var releaseSearch = null;

  function bindGlobalDrawers() {
    if (globalsBound) return;
    globalsBound = true;

    var mobileMenu = $('#mobile-menu');
    var menuOverlay = $('#menu-overlay');
    var menuClose = $('#mobile-menu-close');
    var searchDrawer = $('#search-drawer');
    var searchOverlay = $('#search-overlay');
    var searchClose = $('#search-drawer-close');

    window.hkCloseMobileMenu = function () {
      if (!mobileMenu || !mobileMenu.classList.contains('is-open')) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (menuOverlay) menuOverlay.classList.remove('is-visible');
      HK.unlockScroll();
      $$('.header-hamburger').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (releaseMenu) { releaseMenu(); releaseMenu = null; }
    };

    window.hkOpenMobileMenu = function (opener) {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (menuOverlay) menuOverlay.classList.add('is-visible');
      HK.lockScroll();
      $$('.header-hamburger').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      releaseMenu = HK.trapFocus(mobileMenu, opener);
    };

    window.hkCloseSearch = function () {
      if (!searchDrawer || !searchDrawer.classList.contains('is-open')) return;
      searchDrawer.classList.remove('is-open');
      if (searchOverlay) searchOverlay.classList.remove('is-visible');
      HK.unlockScroll();
      $$('.header-search-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (releaseSearch) { releaseSearch(); releaseSearch = null; }
    };

    window.hkOpenSearch = function (opener) {
      if (!searchDrawer) return;
      searchDrawer.classList.add('is-open');
      if (searchOverlay) searchOverlay.classList.add('is-visible');
      HK.lockScroll();
      $$('.header-search-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      releaseSearch = HK.trapFocus(searchDrawer, opener);
      var inp = $('input[type=search]', searchDrawer);
      if (inp) setTimeout(function () { inp.focus(); }, 120);
    };

    on(menuOverlay, 'click', function () { window.hkCloseMobileMenu(); });
    on(menuClose, 'click', function () { window.hkCloseMobileMenu(); });
    on(searchOverlay, 'click', function () { window.hkCloseSearch(); });
    on(searchClose, 'click', function () { window.hkCloseSearch(); });

    /* Mobil menude linke tiklayinca kapansin (accordion tetikleyicileri haric) */
    if (mobileMenu) {
      on(mobileMenu, 'click', function (e) {
        var a = e.target.closest('a[href]');
        if (a) window.hkCloseMobileMenu();
      });

      /* Mobil menu alt kategori accordion'u */
      $$('[data-mobile-sub-trigger]', mobileMenu).forEach(function (btn) {
        on(btn, 'click', function () {
          var panel = btn.nextElementSibling;
          if (!panel) return;
          var open = panel.hasAttribute('hidden');
          if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', String(open));
          btn.classList.toggle('is-open', open);
        });
      });
    }

    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      window.hkCloseMobileMenu();
      window.hkCloseSearch();
    });
  }

  /* ================= Header ================= */
  HK.register('#site-header', function (header) {
    bindGlobalDrawers();

    $$('.header-hamburger', header).forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      on(btn, 'click', function () {
        var menu = $('#mobile-menu');
        if (menu && menu.classList.contains('is-open')) window.hkCloseMobileMenu();
        else window.hkOpenMobileMenu(btn);
      });
    });

    $$('.header-search-btn', header).forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      on(btn, 'click', function () {
        var d = $('#search-drawer');
        if (d && d.classList.contains('is-open')) window.hkCloseSearch();
        else window.hkOpenSearch(btn);
      });
    });

    /* ---- Mega menu: hover + tiklama + klavye ----
       Onceki surumde yalnizca mouseenter/focus ile aciliyordu, tiklama hicbir sey
       yapmiyordu ve tetikleyiciden cikinca kapanmiyordu. */
    var hideTimer = null;
    var openPanel = null;

    function panelFor(id) { return $('[data-mega-panel="' + id + '"]'); }

    function closeMega() {
      clearTimeout(hideTimer);
      $$('[data-mega-panel]').forEach(function (p) { p.classList.remove('is-open'); });
      $$('[data-mega-trigger]', header).forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      openPanel = null;
    }

    function openMega(trigger) {
      var panel = panelFor(trigger.dataset.megaTrigger);
      if (!panel) return;
      clearTimeout(hideTimer);
      if (openPanel && openPanel !== panel) closeMega();
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openPanel = panel;
    }

    function closeSoon() { clearTimeout(hideTimer); hideTimer = setTimeout(closeMega, 180); }

    $$('[data-mega-trigger]', header).forEach(function (trigger) {
      var panel = panelFor(trigger.dataset.megaTrigger);
      trigger.setAttribute('aria-expanded', 'false');

      on(trigger, 'mouseenter', function () { openMega(trigger); });
      on(trigger, 'mouseleave', closeSoon);
      on(trigger, 'click', function (e) {
        e.preventDefault();
        if (openPanel === panel) closeMega(); else openMega(trigger);
      });
      on(trigger, 'keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openMega(trigger);
          var first = panel && panel.querySelector('a[href]');
          if (first) first.focus();
        }
      });
      if (panel) {
        on(panel, 'mouseenter', function () { clearTimeout(hideTimer); });
        on(panel, 'mouseleave', closeSoon);
        on(panel, 'focusout', function (e) {
          if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) closeSoon();
        });
      }
    });

    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeMega(); });
    on(document, 'click', function (e) {
      if (!e.target.closest('[data-mega-trigger]') && !e.target.closest('[data-mega-panel]')) closeMega();
    });
  });

  /* ================= Hero Slider ================= */
  HK.register('[data-hero-slider]', function (el) {
    var slides = $$('[data-slide]', el);
    if (slides.length < 2) return;

    var dots = $$('[data-slide-dot]', el);
    var current = 0;
    var timer = null;
    var interval = parseInt(el.dataset.interval, 10) || 5000;
    var autoplay = el.dataset.autoplay === 'true' && !HK.prefersReducedMotion();

    function paint() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
        s.setAttribute('aria-hidden', String(i !== current));
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-current', String(i === current));
      });
    }
    function go(i) {
      current = ((i % slides.length) + slides.length) % slides.length;
      paint();
    }
    function start() { stop(); if (autoplay) timer = setInterval(function () { go(current + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, i) { on(d, 'click', function () { go(i); start(); }); });
    on($('[data-slide-prev]', el), 'click', function () { go(current - 1); start(); });
    on($('[data-slide-next]', el), 'click', function () { go(current + 1); start(); });

    on(el, 'mouseenter', stop);
    on(el, 'mouseleave', start);
    on(el, 'focusin', stop);
    on(el, 'focusout', start);
    on(document, 'visibilitychange', function () { document.hidden ? stop() : start(); });

    /* Dokunmatik kaydirma */
    var sx = 0, sy = 0;
    on(el, 'touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    on(el, 'touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { go(current + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });

    paint();
    start();
  });

  /* ================= Accordion ================= */
  HK.register('.product-accordion', function (root) {
    $$('.product-accordion__trigger', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var item = btn.closest('.product-accordion__item');
        var content = (item && item.querySelector('.product-accordion__content')) || btn.nextElementSibling;
        if (!content) return;
        var isOpen = content.classList.contains('is-open');
        $$('.product-accordion__content', root).forEach(function (c) { c.classList.remove('is-open'); });
        $$('.product-accordion__trigger', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          content.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  /* ================= Adet secici ================= */
  HK.register('[data-qty-selector]', function (el) {
    var dec = $('[data-qty-dec]', el);
    var inc = $('[data-qty-inc]', el);
    var inp = $('input', el);
    if (!inp) return;

    function ceiling() {
      var dataMax = parseInt(el.dataset.qtyMax, 10);
      if (!isNaN(dataMax) && dataMax > 0) return dataMax;
      var attrMax = parseInt(inp.getAttribute('max'), 10);
      if (!isNaN(attrMax) && attrMax > 0) return attrMax;
      return Infinity;
    }
    function floorVal() {
      var m = parseInt(inp.getAttribute('min'), 10);
      return (!isNaN(m) && m > 0) ? m : 1;
    }
    function warnMax(max) {
      HK.toast('Bu urunden ' + (max === 1 ? 'yalnizca 1 adet' : 'en fazla ' + max + ' adet') + ' ekleyebilirsiniz (stok siniri).');
    }

    on(dec, 'click', function () {
      var v = (parseInt(inp.value, 10) || floorVal()) - 1;
      if (v < floorVal()) v = floorVal();
      inp.value = v;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    on(inc, 'click', function () {
      var max = ceiling();
      var v = (parseInt(inp.value, 10) || floorVal()) + 1;
      if (v > max) { v = max; warnMax(max); }
      inp.value = v;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    on(inp, 'change', function () {
      var max = ceiling();
      var v = parseInt(inp.value, 10);
      if (isNaN(v) || v < floorVal()) v = floorVal();
      if (v > max) { v = max; warnMax(max); }
      if (String(v) !== inp.value) inp.value = v;
    });
  });

  /* ================= Mobil filtre drawer ================= */
  HK.register('#filter-drawer', function (drawer) {
    var overlay = $('#filter-overlay');
    var release = null;

    function open(opener) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      HK.lockScroll();
      release = HK.trapFocus(drawer, opener);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      HK.unlockScroll();
      if (release) { release(); release = null; }
    }

    $$('[data-filter-open], #filter-drawer-open').forEach(function (b) {
      on(b, 'click', function () { open(b); });
    });
    $$('#filter-drawer-close, [data-filter-close]').forEach(function (b) { on(b, 'click', close); });
    on(overlay, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  });

  /* ================= Sekmeler ================= */
  HK.register('[data-tabs]', function (tabs) {
    var triggers = $$('[data-tab]', tabs);
    var panels = $$('[data-tab-panel]', tabs);
    triggers.forEach(function (t) {
      on(t, 'click', function () {
        triggers.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (x) { x.classList.add('hidden'); });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');
        var panel = $('[data-tab-panel="' + t.dataset.tab + '"]', tabs);
        if (panel) panel.classList.remove('hidden');
      });
    });
  });

  /* ================= Geri sayim =================
     ONEMLI: sure dolunca 00:00:00:00 BIRAKILMAZ.
     data-hide-on-expire="section" -> tum bolum gizlenir
     data-hide-on-expire="timer"   -> yalnizca sayac gizlenir, icerik evergreen kalir */
  HK.register('[data-countdown]', function (el) {
    var raw = (el.dataset.end || '').trim();
    if (!raw) { el.hidden = true; return; }
    var end = new Date(raw.indexOf('T') > -1 ? raw : raw + 'T23:59:59');
    if (isNaN(end.getTime())) { el.hidden = true; return; }

    var mode = el.dataset.hideOnExpire || 'section';
    var section = el.closest('[data-section]');
    var timer = null;

    function expire() {
      if (timer) clearInterval(timer);
      if (mode === 'section' && section) section.hidden = true;
      else el.hidden = true;
    }
    function set(key, val) {
      var node = $('[data-countdown-' + key + ']', el);
      if (node) node.textContent = String(val).padStart(2, '0');
    }
    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) { expire(); return; }
      set('days', Math.floor(diff / 864e5));
      set('hours', Math.floor((diff % 864e5) / 36e5));
      set('minutes', Math.floor((diff % 36e5) / 6e4));
      set('seconds', Math.floor((diff % 6e4) / 1e3));
    }

    if (end.getTime() - Date.now() <= 0) { expire(); return; }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ================= Sticky urun cubugu ================= */
  HK.register('#product-sticky-bar', function (bar) {
    var addBtn = $('#product-add-btn');
    if (!addBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting);
      bar.setAttribute('aria-hidden', String(e.isIntersecting));
    }, { threshold: 0 }).observe(addBtn);
  });

  /* ================= Kurulum ================= */
  function boot() { HK.initAll(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme Editor: bolum yeniden yuklendiginde JS'i tekrar kur */
  document.addEventListener('shopify:section:load', function (e) { HK.initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { HK.unlockScroll(true); });

  /* AJAX ile eklenen icerik (koleksiyon "Daha Fazla Goster") */
  document.addEventListener('collection:appended', function () { HK.initAll(document); });
})();
